// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1XvST","label":"Section_label__1A6Kr","contentWrap":"Section_contentWrap__3PaS5","footer":"Section_footer__2wKxO","footerInner":"Section_footerInner__2dAH-"};